import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import { callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const { Option } = Select;

  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          title: recordData?.title,
          content: recordData?.content,
          parent: recordData?.parent,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        routes.getAllCategories,
        null,
        setIsLoading,
        (res) => {
          console.log("Categories.....", res);
          if (res.status === 200) {
            setCategories(res?.data?.categories);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          ...values,
          parent: values.parent || null,
        };
        console.log("body", requestBody);

        const getRes = (res) => {
          console.log("Response got", res);
          if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Sub Category Updated Successfully"
                : "Sub Category Created Successfully"
            );
            toggleModal();
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.updateSubCategorie}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createSubCategorie}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          console.error("API call error", error);
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={recordData ? "Update Sub Category" : "Create Sub Category"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Category"
          name="parent"
          rules={[{ required: true, message: "Please select Category" }]}
        >
          <Select placeholder="Select Category">
            {categories.map((category) => (
              <Option key={category._id} value={category._id}>
                {category.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please enter the name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Content"
          name="content"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <Input.TextArea autoSize />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddVideo;
